import { AsyncPipe, NgIf } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { Observable } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';
import { BaseUtenteComponent } from 'src/app/components/base-utente/base-utente.component';
import { GenNota } from 'src/app/models/anagrafiche/gen-nota';
import { ExtEntityInfoPars } from 'src/app/models/gestione/ext-entity-info-pars';
import { LookupDto } from 'src/app/models/lookup/lookup-dto';
import { createToastMessageData } from 'src/app/models/message';
import { AppManagerService } from 'src/app/services/app-manager.service';
import { DataService } from 'src/app/services/data.service';
import { GenNotaService } from 'src/app/services/gennota.service';
import { GenLookupService } from 'src/app/services/lookup/gen-lookup.service';
import { Resources, TranslateService } from 'src/app/services/translate.service';
import { dateFormat } from 'src/app/utils/util';
import { TranslateItemPipe } from '../../../../pipes/translate-item.pipe';

@Component({
  selector: 'app-gen-nota-add',
  templateUrl: './gen-nota-add.component.html',
  styles: ``,
  standalone: true,
  imports: [
    AsyncPipe,
    ButtonModule,
    DialogModule,
    DropdownModule,
    InputTextareaModule,
    NgIf,
    ReactiveFormsModule,
    TranslateItemPipe
  ]
})
export class GenNotaAddComponent extends BaseUtenteComponent {
  dateFormat: string = dateFormat;
  T$!: Observable<Resources>;
  moadlNotaAdd$: Observable<ExtEntityInfoPars>;
  tipiNoteList$: Observable<LookupDto[]>;
  dataForm: FormGroup;
  elaboration: boolean = false;
  resourceList: Resources;
  visible: boolean = false;

  @Output() readonly onHide = new EventEmitter<boolean>();

  constructor(
    private readonly dataService: DataService,
    private readonly translateService: TranslateService,
    private readonly fb: FormBuilder,
    public override readonly appManagerService: AppManagerService,
    private readonly genNotaService: GenNotaService,
    private readonly genLookupService: GenLookupService
  ) {
    super(appManagerService);
  }

  onUtenteInit(): void {
    this.moadlNotaAdd$ = this.genNotaService.getNotaSubject();

    // Etichette
    this.T$ = this.translateService
      .translatedItems$(['generic.', 'gennote.'])
      .pipe(tap((translateItems) => (this.resourceList = translateItems)));

    // Carico i tipi di note
    this.tipiNoteList$ = this.moadlNotaAdd$.pipe(
      filter((data: ExtEntityInfoPars) => data.open),
      tap((data: ExtEntityInfoPars) => {
        const { extId, extTableName } = data;
        this.visible = data.open;
        this.dataForm.reset({ extId, extTableName, id: 0, ambitoId: 0, oggetto: '' }, { emitEvent: false });
      }),
      switchMap((data: ExtEntityInfoPars) => this.genLookupService.getGenNotaTipoLookup$(data.extTableName))
    );

    // Costruisco il form
    this.dataForm = this.fb.group({
      id: 0,
      ambitoId: [0, Validators.required],
      extId: [null, Validators.required],
      notaTipoId: [null, Validators.required],
      oggetto: null,
      nota: [null, Validators.required],
      userIns: null,
      dtIns: null,
      userUpd: null,
      dtUpd: null,
      notaTipoDes: null,
      extTableName: [null, Validators.required]
    });
  }

  hideModal(): void {
    this.visible = false;
    this.onHide.emit(false);
  }

  save(): void {
    this.elaboration = true;
    const data = this.dataForm.value as GenNota;

    this.dataService
      .insertElement<GenNota>(`${this.dataService.configSettings.restCommonUrl}/gennota`, data)
      .subscribe({
        next: (_data: GenNota) => {
          this.elaboration = false;
          this.appManagerService.showToastMessage(
            createToastMessageData(
              'success',
              this.translateService.translate(this.resourceList, 'generic.savesuccessmsg')
            )
          );
          this.hideModal();
        },
        error: (_error: HttpErrorResponse) => {
          this.elaboration = false;
        }
      });
  }
}
